export default __webpack_public_path__ + "static/l2-feature-img-1-bc9d160168e565dbe299bb3bf2e915b9.png";